module.exports = __webpack_public_path__ + "static/media/my-cart-active.95aa104e.svg";